/** Telegram Stars (в API/Marketplace код XTR, в UI показываем как Stars). */

export const STARS_CURRENCY_CODE = 'XTR';
export const STARS_CURRENCY_LABEL = 'Stars';

const STARS_CURRENCY_ALIASES = new Set(['', 'xtr', 'stars', 'star', '⭐', 'tgstars']);

export function isStarsCurrency(currency) {
    const raw = String(currency ?? '').trim().toLowerCase();
    return STARS_CURRENCY_ALIASES.has(raw);
}

export function formatStarsAmount(value, { fallback = '—', maximumFractionDigits = 9 } = {}) {
    if (value === null || value === undefined || value === '') return fallback;
    const amount = Number(value);
    if (!Number.isFinite(amount)) return fallback;
    return `${amount.toLocaleString('ru-RU', { maximumFractionDigits })} ${STARS_CURRENCY_LABEL}`;
}

/** Цена каталога / маркетплейса: XTR и пустая валюта → Stars. */
export function formatGiftPrice(price, currency) {
    if (price === null || price === undefined || price === '') return '—';
    const amount = Number(price);
    if (!Number.isFinite(amount)) return '—';
    const formatted = amount.toLocaleString('ru-RU', { maximumFractionDigits: 9 });
    if (isStarsCurrency(currency)) {
        return `${formatted} ${STARS_CURRENCY_LABEL}`;
    }
    const code = String(currency || '').trim().toUpperCase();
    return code ? `${formatted} ${code}` : `${formatted} ${STARS_CURRENCY_LABEL}`;
}
